// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

.monaco-editor div.inline-edits-widget {
	--widget-color: var(--vscode-notifications-background);

	.promptEditor .monaco-editor {
		--vscode-editor-placeholder-foreground: var(--vscode-editorGhostText-foreground);
	}

	.toolbar, .promptEditor {
		opacity: 0;
		transition: opacity 0.2s ease-in-out;
	}
	&:hover, &.focused {
		.toolbar, .promptEditor {
			opacity: 1;
		}
	}

	.preview .monaco-editor {

		.mtk1 {
			/*color: rgba(215, 215, 215, 0.452);*/
			color: var(--vscode-editorGhostText-foreground);
		}
		.view-overlays .current-line-exact {
			border: none;
		}

		.current-line-margin {
			border: none;
		}

		--vscode-editor-background: var(--widget-color);
	}

	svg {
		.gradient-start {
			stop-color: var(--vscode-editor-background);
		}

		.gradient-stop {
			stop-color: var(--widget-color);
		}
	}
}
`, "",{"version":3,"sources":["webpack://./node_modules/monaco-editor/esm/vs/editor/contrib/inlineEdits/browser/inlineEditsWidget.css"],"names":[],"mappings":"AAAA;;;+FAG+F;;AAE/F;CACC,sDAAsD;;CAEtD;EACC,gFAAgF;CACjF;;CAEA;EACC,UAAU;EACV,oCAAoC;CACrC;CACA;EACC;GACC,UAAU;EACX;CACD;;CAEA;;EAEC;GACC,qCAAqC;GACrC,+CAA+C;EAChD;EACA;GACC,YAAY;EACb;;EAEA;GACC,YAAY;EACb;;EAEA,+CAA+C;CAChD;;CAEA;EACC;GACC,2CAA2C;EAC5C;;EAEA;GACC,+BAA+B;EAChC;CACD;AACD","sourcesContent":["/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-editor div.inline-edits-widget {\n\t--widget-color: var(--vscode-notifications-background);\n\n\t.promptEditor .monaco-editor {\n\t\t--vscode-editor-placeholder-foreground: var(--vscode-editorGhostText-foreground);\n\t}\n\n\t.toolbar, .promptEditor {\n\t\topacity: 0;\n\t\ttransition: opacity 0.2s ease-in-out;\n\t}\n\t&:hover, &.focused {\n\t\t.toolbar, .promptEditor {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t.preview .monaco-editor {\n\n\t\t.mtk1 {\n\t\t\t/*color: rgba(215, 215, 215, 0.452);*/\n\t\t\tcolor: var(--vscode-editorGhostText-foreground);\n\t\t}\n\t\t.view-overlays .current-line-exact {\n\t\t\tborder: none;\n\t\t}\n\n\t\t.current-line-margin {\n\t\t\tborder: none;\n\t\t}\n\n\t\t--vscode-editor-background: var(--widget-color);\n\t}\n\n\tsvg {\n\t\t.gradient-start {\n\t\t\tstop-color: var(--vscode-editor-background);\n\t\t}\n\n\t\t.gradient-stop {\n\t\t\tstop-color: var(--widget-color);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
